import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridAngular } from 'ag-grid-angular';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InventoryRequestService } from 'src/app/vendor-data/inventory-request-lists/inventory-request.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { GridOptions, GridApi, ColDef } from 'ag-grid-community';
import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';

@Component({
  selector: 'app-inventory-search',
  standalone: true,
  templateUrl: './inventory-search.component.html',
  styleUrls: ['./inventory-search.component.scss'],
  imports: [FormsModule, NgSelectModule, AgGridAngular],
})
export class InventorySearchComponent implements OnInit {
  manufacturer: string = null;
  description: string = null;
  manufacturers: string[] = [];
  isSearching: boolean = false;
  searchResults: any[] = [];
  theme = agGridDarkTheme;

  gridApi!: GridApi;
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,
    rowHeight: 30,
    headerHeight: 40
  };
  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    floatingFilter: true
  };
  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading Data... <i class="fa-solid fa-spinner fa-spin ms-2"></i></span>';
  overlayNoRowsTemplate = '<span class="ag-overlay-loading-center">No results found or narrow your search</span>';

  columnDefs: ColDef[] = [
    { headerName: 'UPC', field: 'upc', width: 140 },
    { headerName: 'Manufacturer', field: 'manufacturer', width: 150 },
    { headerName: 'MFG Part Number', field: 'mfg_part_number', width: 160 },
    { headerName: 'Item Number', field: 'item_number', width: 150 },
    { headerName: 'Description', field: 'desc1', flex: 1, minWidth: 200 },
    { headerName: 'MSRP', field: 'msrp.$numberDecimal', width: 100, valueFormatter: (params) => params.value ? `$${parseFloat(params.value).toFixed(2)}` : '' },
    { headerName: 'MAP', field: 'map_price.$numberDecimal', width: 100, valueFormatter: (params) => params.value ? `$${parseFloat(params.value).toFixed(2)}` : '' },
    { headerName: 'RSR QTY', field: 'rsr_group_available_qty', width: 100 },
    { headerName: 'Zanders QTY', field: 'zanders_available_qty', width: 100 },
    { headerName: 'Davidsons QTY', field: 'davidsons_available_qty', width: 100 },
    { headerName: 'Lipseys QTY', field: 'lipseys_available_qty', width: 100 },
    { headerName: 'Allen Arms QTY', field: 'allen_arms_available_qty', width: 100 },
  ];

  constructor(
    public bsModalRef: BsModalRef,
    private inventoryService: InventoryRequestService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.fetchManufacturers();
  }

  fetchManufacturers() {
    this.inventoryService.getAllManufacturers().subscribe({
      next: (data) => {
        this.manufacturers = data;
      },
      error: (err) => {
        console.error('Error fetching manufacturers', err);
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  searchDatabase() {
    if (!this.manufacturer && !this.description) return;
    
    this.isSearching = true;
    if (this.gridApi) {
      this.gridApi.showLoadingOverlay();
    }
    
    this.inventoryService.searchAdvancedInventory(this.manufacturer, this.description).subscribe({
      next: (results) => {
        this.searchResults = results;
        this.isSearching = false;
        if (this.searchResults.length === 0 && this.gridApi) {
          this.gridApi.showNoRowsOverlay();
        } else if (this.gridApi) {
          this.gridApi.hideOverlay();
        }
      },
      error: (err) => {
        console.error(err);
        this.isSearching = false;
        this.sharedService.raiseErrorToast('Search failed');
        if (this.gridApi) this.gridApi.hideOverlay();
      }
    });
  }

  onRowSelected(event: any) {
    const selectedItem = event.data;
    this.sharedService.inventory_search_item_selected$.next(selectedItem);
    this.closeModalClick();
  }

  closeModalClick() {
    this.bsModalRef.hide();
  }
}
